/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./logoCustom.vue?vue&type=template&id=602ae548&scoped=true&"
import script from "./logoCustom.vue?vue&type=script&lang=js&"
export * from "./logoCustom.vue?vue&type=script&lang=js&"
import style0 from "./logoCustom.vue?vue&type=style&index=0&id=602ae548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ae548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
